import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { stempelerfassungRoutes } from '@softapps/pms/stempelerfassung';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { einseitigeLagerbuchungRoutes } from '@softapps/mde/einseitige-lagerbuchung';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { vehicleRoutes } from '@softapps/werkstatt/vehicle';
import { auftragRoutes } from '@softapps/werkstatt/auftrag';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  //Wws
  ...gesamtabfrageRoutes,
  ...stempelerfassungRoutes,

  // MDE
  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...lagerInventurRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...artikelInfoRoutes,
  ...artikelvorratRoutes,
  ...materiallieferscheinScanRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];


/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      //Wws
      // ...gesamtabfrageRoutes,
      ...stempelerfassungRoutes,

      // MDE
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...artikelInfoRoutes,
      ...artikelvorratRoutes,
      ...materiallieferscheinScanRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
];
*/
